import { ApplicationBookingState } from '@flatsy/types/Applications'
import { AssignmentMode } from '@flatsy/types/ViewingSettings/ViewingSettings'
import { AssetStatus } from 'src/redux/slices/Assets/Type'
import { WizardContext } from '../wizardMachine'

/**
 * @description return false if booking status is invited or if slot.length is 0
 * @returns boolean
 */
export const isInWaitingList = (context: WizardContext): boolean => {
  const { asset, application, slots } = context

  // If asset is on call and no slots then in waiting list
  if (
    asset?.viewing_settings?.assignment_mode === AssignmentMode.ON_CALL_ASSIGNMENT &&
    !slots?.length
  ) {
    return true
  }

  // booking_state is AUTHORIZED then not in waiting list
  if (application && application.booking_state === ApplicationBookingState.AUTHORIZED) {
    return false
  }

  // Asset status is STANDBY then in waiting list
  if (asset && asset.status === AssetStatus.STANDBY) {
    return true
  }

  return false
}
